import store from "../../../../store";
import sb_doc_create from "./sb_doc_create.vue";

window.SB_DOC_CREATE =  new Vue({
    store,
    name : "SB_DOC_CREATE",
    el: '#sb_doc_create',

    data () {
        return {
            showModal: false,
        }
    },
    created () {

    },

    components : {
        sb_doc_create
    }
});
